import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Card = props => <div className="c-vi-card">{props.children}</div>;

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Card;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Card.jsx